export function extractCustomerBatchDownload(payload: unknown): {
  fileUrl: string;
  fileName: string;
} {
  const row =
    payload && typeof payload === "object"
      ? (payload as Record<string, unknown>)
      : {};
  const fileUrl = String(
    row.file_url || row.fileUrl || row.download_url || row.downloadUrl || ""
  ).trim();
  const fileName = String(row.file_name || row.fileName || "").trim();
  return { fileUrl, fileName };
}

export function triggerBrowserDownload(url: string, fileName?: string) {
  const anchor = document.createElement("a");
  anchor.href = url;
  if (fileName) anchor.download = fileName;
  anchor.rel = "noopener";
  anchor.target = "_blank";
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
